// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\PSixServiceSearchResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PSixServiceVessel, PSixServiceVesselData, PSixServiceVesselOptions } from 'data/models/PSixServiceVessel';

// PSixServiceSearchData is the class that PSixServiceSearch serializes to/from
export interface PSixServiceSearchData {
    CallSign : string | null;
    HIN : string | null;
    VesselName : string | null;
    VIN : string | null;
	
    Results : PSixServiceVesselData[] | null;
	
}

// PSixServiceSearchOptions is the class which may be passed to the PSixServiceSearch constructor to define optional initial data values
export interface PSixServiceSearchOptions {
    CallSign : string | null;
    HIN : string | null;
    VesselName : string | null;
    VIN : string | null;
	
    Results? : PSixServiceVesselOptions[] | null;
	
}

export class PSixServiceSearch {
    public CallSign : DataSignal<string | null>;
    public HIN : DataSignal<string | null>;
    public VesselName : DataSignal<string | null>;
    public VIN : DataSignal<string | null>;
	
    public Results : SDataArray<PSixServiceVessel>;
	

    constructor();
    constructor(data : PSixServiceSearchOptions);
    constructor(data: PSixServiceSearchOptions | null = null) {
        this.CallSign = jsonableObservable(S.value<string | null>(data && data.CallSign !== undefined ? data.CallSign : null));
        this.HIN = jsonableObservable(S.value<string | null>(data && data.HIN !== undefined ? data.HIN : null));
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
        this.VIN = jsonableObservable(S.value<string | null>(data && data.VIN !== undefined ? data.VIN : null));
	    
        this.Results = SArray<PSixServiceVessel>([]);
	    
    }

    static key(obj : PSixServiceSearch) {
        return (obj.CallSign() === null ? '\u2603' : obj.CallSign()!) + '\u2618' + (obj.HIN() === null ? '\u2603' : obj.HIN()!) + '\u2618' + (obj.VesselName() === null ? '\u2603' : obj.VesselName()!) + '\u2618' + (obj.VIN() === null ? '\u2603' : obj.VIN()!);
    }
    
    static dataKey(obj : PSixServiceSearchOptions) {
        return (obj.CallSign === null ? '\u2603' : obj.CallSign) + '\u2618' + (obj.HIN === null ? '\u2603' : obj.HIN) + '\u2618' + (obj.VesselName === null ? '\u2603' : obj.VesselName) + '\u2618' + (obj.VIN === null ? '\u2603' : obj.VIN);
    }

    static update(obj : PSixServiceSearch, data : PSixServiceSearchOptions) {
        S.freeze(() => {
            if (data.CallSign !== undefined) obj.CallSign(data.CallSign);
            if (data.HIN !== undefined) obj.HIN(data.HIN);
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
            if (data.VIN !== undefined) obj.VIN(data.VIN);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PSixServiceSearch.ts